import * as React from 'react';
import { Dayjs } from 'dayjs';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Stack from '@mui/material/Stack';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../../theme/muiTheme';
import { DatePicker } from '@mui/x-date-pickers';
import CONSTANTS from '../../utils/constants/UIConstants';

interface ExportDatePickerProps {
	label: string;
	value: Dayjs | null;
	onChange: (value: unknown, keyboardInputValue?: string) => void;
	addStyle?: string;
	disabled?: boolean;
}

const ExportDatePicker: React.FC<ExportDatePickerProps> = (props) => {
	return (
		<ThemeProvider theme={theme}>
			<LocalizationProvider dateAdapter={AdapterDayjs}>
				<Stack spacing={1}>
					<DatePicker
						value={props.value}
						onChange={props.onChange}
						label={props.label}
						onError={console.log}
						inputFormat="YYYY/MM/DD"
						mask="____/__/__"
						disabled={props.disabled}
						renderInput={(params) => (
							<TextField
								{...params}
								InputLabelProps={{
									...params.InputLabelProps,
									shrink: !!props.value,
								}}
								className={props.addStyle}
								label={props.label}
								style={{
									width: '338px',
									height: '48px',
									fontFamily: 'Jost, sans-serif !important',
								}}
								size="small"
								sx={{
								...(!props.disabled
									? {}
									: {
										'.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
										border: 'none',
										},
										'.Mui-disabled': {
										color: '#556670',
										},
										'.MuiFormLabel-root.Mui-disabled': {
										color: '#556670',
										},
									}
								),
								'& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
									transform: 'translate(14px, 13px) scale(1)',
								},

								'& .MuiInputLabel-root.MuiInputLabel-shrink': {
									backgroundColor: CONSTANTS.TEXT_INPUT_LABEL_BACKGROUND,
								},

								'& .MuiInputLabel-shrink ~ .MuiOutlinedInput-notchedOutline legend': {
									boxSizing: 'border-box',
									backgroundColor: CONSTANTS.TEXT_INPUT_LABEL_BACKGROUND,
									padding: '0 4px',
								},
								}}
							/>
						)}
						ToolbarComponent={() => null}
						componentsProps={{
							actionBar: { actions: ['accept', 'cancel'] },
						}}
					/>
				</Stack>
			</LocalizationProvider>
		</ThemeProvider>
	);
};

export default ExportDatePicker;